export default "__VITE_ASSET__BG2yeEVx__"